import { MdKeyboardArrowDown } from "react-icons/md";
import styled from "styled-components";

const checkColor = (primaryColor, checkoutColor, suffix = "") => {
  if (checkoutColor === "#ffffff") {
    if (primaryColor === "#ffffff") {
      return `#303030${suffix}`;
    } else {
      return `${primaryColor}${suffix}`;
    }
  } else {
    return `${checkoutColor}${suffix}`;
  }
};

export const WrapperSelectContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  width: 100%;
`;

export const SelectContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  width: 100%;
  position: relative;

  svg {
    pointer-events: none;
  }
`;

export const ArrowDownIcon = styled(MdKeyboardArrowDown)`
  font-size: 1.5rem;
  color: ${({ theme }) => theme.groups?.primaryText};

  position: absolute;
  right: 1rem;
  z-index: 1;
`;

export const InputComponent = styled.input`
  width: 100%;
  height: 3.5rem;
  padding: 0 1rem;

  font-family: Inter;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5rem;

  background: ${({ theme }) => {
    if (theme.mode === "light") {
      return "#FFFFFF";
    } else {
      const primaryColor = theme?.colors?.primary;
      const checkoutColor = theme?.checkoutStepsOffers?.checkoutPrimaryColor;

      return checkColor(primaryColor, checkoutColor, "25");
    }
  }};

  border-radius: 0.5rem;
  border: 0.125rem solid
    ${(props) => props.theme?.controlPanel.tools.containerBorderColor};

  cursor: pointer;

  &:disabled {
    opacity: 0;
    cursor: not-allowed;
  }
`;

export const SelectField = styled.input`
  display: flex;
  align-items: center;

  width: 100%;
  height: 3.5rem;
  padding: 0 1rem;

  font-family: Inter;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5rem;
  color: ${({ theme }) => theme.groups?.primaryText};

  background: ${({ theme }) => {
    if (theme.mode === "light") {
      return "#FFFFFF";
    } else {
      const primaryColor = theme?.colors?.primary;
      const checkoutColor = theme?.checkoutStepsOffers?.checkoutPrimaryColor;

      return checkColor(primaryColor, checkoutColor, "25");
    }
  }};

  border-radius: 0.5rem;
  border: 0.125rem solid
    ${(props) => props.theme?.controlPanel.tools.containerBorderColor};
  cursor: pointer;

  position: absolute;
  z-index: 1;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ListOptionsContainer = styled.div`
  display: flex;
  align-items: flex-start;

  justify-content: center;

  width: 100%;
  max-height: 14rem;
  overflow-y: scroll;

  border-radius: 0.25rem;

  background: ${({ theme }) => {
    if (theme.mode === "light") {
      return "#FFFFFF";
    } else {
      const primaryColor = theme?.colors?.primary;
      const checkoutColor = theme?.checkoutStepsOffers?.checkoutPrimaryColor;

      return checkColor(primaryColor, checkoutColor);
    }
  }};

  position: absolute;
  z-index: 2;
  top: 0;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: inherit;
    background: inherit;

    filter: ${({ theme }) =>
      theme.mode === "light" ? "brightness(1)" : "brightness(0.60)"};

    z-index: -1;
  }

  &::-webkit-scrollbar {
    width: 0.5rem;
  }

  &::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.groups?.listOffersScrollbarTrack};
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.groups?.listOffersScrollbarThumb};
    border-radius: 20px;
    border: 0.063rem solid
      ${({ theme }) => theme.groups?.listOffersScrollbarThumbBorder};
  }
`;

export const ListOptionsWrapper = styled.div`
  position: relative;
  max-height: 14rem;
  overflow-y: auto;
  width: 100%;

  &::-webkit-scrollbar {
    width: 0.5rem;
  }

  &::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.groups?.listOffersScrollbarTrack};
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.groups?.listOffersScrollbarThumb};
    border-radius: 20px;
    border: 0.063rem solid
      ${({ theme }) => theme.groups?.listOffersScrollbarThumbBorder};
  }
`;

export const ListOptions = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  width: 100%;
  border-radius: 0.25rem;
`;

export const Option = styled.button`
  display: flex;
  align-items: center;

  width: 100%;
  min-height: 3.5rem;
  padding: 0 1rem;

  font-family: Inter;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5rem;
  color: ${({ theme }) => theme.groups?.primaryText};

  border: none;
  cursor: pointer;
  background: none;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:hover {
    transition: 300ms ease-in;
    background: ${(props) =>
      props.theme?.controlPanel.tools.modalBackgroundColorHover};
  }

  &:first-child {
    border-radius: 0.25rem 0.25rem 0 0;
  }

  &:last-child {
    border-radius: 0 0 0.25rem 0.25rem;
  }
`;

export const ErrorMessage = styled.span`
  width: 100%;
  margin: 0.5rem 0 0;

  font-family: Inter;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5rem;

  color: #ff3737;
`;
